import { Link } from "react-router-dom";
import React, { useContext } from "react";
import ApplicationLogo from "../../../../components/core/ApplicationLogo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { url } from "@/utils";
import Avatar from "@/components/Avatar";
import { UserContext } from "@/context/UserContext";

export default function Navigation() {
  const [open, setOpen] = React.useState(false);
  const userContext = useContext(UserContext);

  if (!userContext) {
    throw new Error("UserContext must be used within a UserProvider");
  }
  const { user } = userContext;

  const toggleMobileMenu = () => {
    setOpen(!open);
  };

  return (
    <div>
      {/* Desktop Menu */}
      <div className="hidden md:block ">
        <nav className=" bg-white w-full flex relative justify-between items-center mx-auto px-8 h-20">
          {/* <!-- logo --> */}
          <ApplicationLogo className="w-20 h-20 fill-current text-gray-500" />
          {/* <!-- end logo --> */}

          {/* <!-- search bar --> */}
          {/* <!-- end search bar --> */}

          {/* <!-- login --> */}
          <div className="flex-initial">
            <div className="flex justify-end items-center relative">
              <Avatar />
            </div>
          </div>
          {/* <!-- end login --> */}
        </nav>
      </div>
      {/* Mobile Menu */}
      <div className="w-full flex justify-end md:hidden text-end p-4">
        <Avatar />
      </div>
    </div>
  );
}
